var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzlePiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0724 22.2679C33.1891 22.2679 31.9404 24.4618 30.3739 24.4618C26.209 24.4618 30 12.2227 30 12.2227C30 12.2227 16.3689 17.7782 16.3689 11.9937C16.3689 9.50571 18.8889 8.78189 18.8889 6.02252C18.8889 3.5571 16.9365 2.22266 14.6208 2.22266C12.2142 2.22266 10.012 3.53453 10.012 6.13557C10.012 9.00807 12.2142 10.252 12.2142 11.8127C12.2142 16.6476 0 13.8031 0 13.8031V36.9445C0 36.9445 12.4052 39.795 12.4052 34.9541C12.4052 33.3935 9.62743 32.1689 9.62743 29.2964C9.62743 26.6953 11.6587 25.3835 14.0425 25.3835C16.3809 25.3835 18.3333 26.7179 18.3333 29.1833C18.3333 31.9427 15.8133 32.6665 15.8133 35.1545C15.8133 39.3769 24.8185 36.9413 28.3988 36.9413C28.3988 36.9413 25.9873 28.6009 30.1923 28.6009C32.6897 28.6009 33.4161 31.1115 36.1859 31.1115C38.6606 31.1115 40 29.1664 40 26.8368C40 24.4618 38.6832 22.2679 36.0724 22.2679Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzlePiece);
export default __webpack_public_path__ + "static/media/puzzle-piece.c8d3d25a0c88eb413107d2288d269863.svg";
export { ForwardRef as ReactComponent };